import { useCategoriesList } from 'app/components/OrgsList/OrgsDishes/Categories/useCategoriesList'
import { useSalePointCategories, useSalePointCategoriesMutate } from 'app/dataProviders/salePoint/categories/hooks'
import { useCallback } from 'react'
import usePopup from 'app/common/hooks/usePopup'

interface Options {
  orgId: number
  salePointId: number
}

export const useSalePointCategoriesState = ({ orgId, salePointId }: Options) => {
  const { data: categoryList, loading: categoriesLoading } = useCategoriesList({ params: { orgId } })
  const { data: selectedData, loading: selectedCategoriesLoading } = useSalePointCategories({ params: { orgId, salePointId } })
  const { submit, pending } = useSalePointCategoriesMutate()
  const popup = usePopup()

  const { categoriesIds, useComplexes, limitSingleItemInPurchase } = selectedData

  const loading =
    categoriesLoading ||
    selectedCategoriesLoading ||
    !categoryList?.length


  const handleSave = useCallback(async (form: HTMLFormElement) => {
    const data = new FormData(form)
    const selectedCategories = data.getAll('categories') as Array<string>
    const useComplexes = data.has('useComplexes')
    const limitSingleItemInPurchase = data.has('withoutProductQuantityRestrictions')
      ? null
      : Number(data.get('maxProductQuantity'))
    const res = await submit({ orgId, salePointId, selectedCategories, useComplexes, limitSingleItemInPurchase })
    if (res) {
      popup('Настройки точки продаж успешно сохранены')
      return !!res
    }
  }, [orgId, salePointId, submit, popup])


  return {
    categoryList,
    selected: categoriesIds,
    selectedComplexes: useComplexes,
    limitSingleItemInPurchase,
    onSave: handleSave,
    loading,
    pending
  }
}
